import { PlanController } from './plan.controller'

function plan () {
  return {
    restrict: 'E',
    scope: {
      date: '<'
    },
    templateUrl: '/admin/directives/plan/plan-directive.html?$$REVISION$$',
    controller: PlanController
  }
}

export { plan }
